import { useFormik } from "formik";
import { get, isEmpty } from "lodash";
import { useTranslation } from "react-i18next";
import useZipCodeCities from "shared/hooks/useZipCodeCities";
import { NAME_SPACES } from "shared/locales/constants";
import { CONTACT_POINT_SYSTEM } from "utils/constants";
import {
  bindInputProps,
  bindWebTextFieldInputProps,
} from "utils/helpers/input";
import Button from "../Components/Button";
import Footer from "../Components/Footer";
import Header from "../Components/Header";
import Input from "../Components/Input";
import Select from "../Components/Select";
import validation from "./validation";

function View({ telecoms, onNext, onBack }) {
  const { t } = useTranslation();

  const { handleSubmit, values, setFieldValue, ...formProps } = useFormik({
    initialValues: { telecoms },
    onSubmit: onNext,
    validationSchema: validation(
      t(`${NAME_SPACES.ERRORS}:VALIDATIONS`, { returnObjects: true }),
    ),
  });
  const zipCode = get(
    values,
    `telecoms.${CONTACT_POINT_SYSTEM.ZIP_CODE}.value`,
  );
  const { cities, loading: citiesLoading } = useZipCodeCities(zipCode);

  return (
    <div className="solyon">
      <div className="solyon__container">
        <div className="solyon__wrapper">
          <Header
            title="Passons à l’adhésion, nous avons besoin de quelques informations complémentaires"
            highlight="informations complémentaires"
            subtitle="Souscription : Informations complémentaires"
            onBack={onBack}
          />
          <div className="solyon__body">
            <div className="grid--1 max-500">
              <Input
                placeholder={"ex : 17, Rue de la victoire"}
                label={"Adresse postale"}
                {...bindWebTextFieldInputProps({
                  name: `telecoms.${CONTACT_POINT_SYSTEM.ADDRESS}.value`,
                  values,
                  setFieldValue,
                  ...formProps,
                })}
              />
              <div className="grid--2">
                <Input
                  placeholder={"ex : 69001"}
                  label={"Code postal"}
                  {...bindInputProps({
                    name: `telecoms.${CONTACT_POINT_SYSTEM.ZIP_CODE}.value`,
                    values,
                    ...formProps,
                  })}
                />
                <Select
                  loading={citiesLoading}
                  options={cities}
                  placeholder={"Sélectionnez ..."}
                  label={"Ville"}
                  {...bindInputProps({
                    name: `telecoms.${CONTACT_POINT_SYSTEM.CITY}.value`,
                    values,
                    ...formProps,
                  })}
                />
              </div>
            </div>
            <div className="solyon__body--actions">
              <Button
                type={"primary"}
                alignment={"center"}
                disabled={
                  !get(
                    values,
                    `telecoms.${CONTACT_POINT_SYSTEM.ADDRESS}.value`,
                  ) || !isEmpty(formProps.errors)
                }
                onClick={handleSubmit}
              >
                Continuer
              </Button>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default View;
